<template>
  
    <div class="WordSection1" style="layout-grid:15.6pt">
      <p
        class="MsoNormal"
        align="center"
        style="text-align:center;mso-pagination:widow-orphan;
background:white"
      >
      <span lang="EN-US" style='font-size:18.0pt;font-family:"Arial",sans-serif'
        >GF-3 Satellite</span
      >
      </p>
      <hr class="divider" />
      <p
        class="MsoNormal"
        align="center"
        style="text-align:center;mso-pagination:widow-orphan;
background:white"
      >
        <span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;font-family:
"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt;
mso-no-proof:yes'
          ><img
            width="500"
            height="300"
            src="../../assets/GF3sat.png"
            v:shapes="图片_x0020_1"/></span
        ><span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
          ><o:p></o:p
        ></span>
      </p>

      <p
        class="MsoNormal"
        style="text-indent:24.0pt;line-height:21.0pt;mso-pagination:
widow-orphan;background:white;text-align: left;"
      >
        <span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;
font-family:"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:
0pt'
          >GF-3 satellite was successfully launched on August 10, 2016. It is
          the first C-band multi-polarization synthetic aperture radar (SAR)
          satellite with <span class="GramE">1 meter</span> resolution in China.
          The Ministry of Natural Resources of China is the main user.<o:p></o:p
        ></span>
      </p>

      <p
        class="MsoNormal"
        style="text-indent:24.0pt;line-height:21.0pt;mso-pagination:
widow-orphan;background:white"
      >
        <b
          ><span
            lang="EN-US"
            style='font-size:12.0pt;
font-family:"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:
0pt'
            >Technical parameters of obit and sensor</span
          ></b
        ><span
          lang="EN-US"
          style='mso-bidi-font-size:10.5pt;font-family:"微软雅黑",sans-serif;mso-bidi-font-family:
宋体;color:#333333;mso-font-kerning:0pt'
          ><o:p></o:p
        ></span>
      </p>

      <table
        class="MsoNormalTable"
        border="1"
        cellspacing="0"
        cellpadding="0"
        align="left"
        width="718"
        style="border-collapse:collapse;border:none;width:95%"
      >
        <thead>
          <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
            <td
              colspan="2"
              style="border:solid #DDDFE4 1.0pt;mso-border-alt:solid #DDDFE4 .75pt;
   background:#C1CCE4;padding:9.0pt 0cm 9.0pt 0cm"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan;mso-element:frame;mso-element-frame-hspace:9.0pt;
   mso-element-wrap:around;mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:
   margin;mso-element-top:-64.95pt;mso-height-rule:exactly"
              >
                <b
                  ><span
                    lang="EN-US"
                    style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
   宋体;mso-font-kerning:0pt"
                    >Item<o:p></o:p></span
                ></b>
              </p>
            </td>
            <td
              width="310"
              colspan="3"
              style="width:232.7pt;border:solid #DDDFE4 1.0pt;
   border-left:none;mso-border-left-alt:solid #DDDFE4 .75pt;mso-border-alt:
   solid #DDDFE4 .75pt;background:#C1CCE4;padding:9.0pt 0cm 9.0pt 0cm"
            >
              <p
                class="MsoNormal"
                align="center"
                style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan;mso-element:frame;mso-element-frame-hspace:9.0pt;
   mso-element-wrap:around;mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:
   margin;mso-element-top:-64.95pt;mso-height-rule:exactly"
              >
                <b
                  ><span
                    lang="EN-US"
                    style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
   宋体;color:black;mso-color-alt:windowtext;mso-font-kerning:0pt"
                    >Parameter</span
                  ></b
                ><b
                  ><span
                    lang="EN-US"
                    style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
   宋体;mso-font-kerning:0pt"
                    ><o:p></o:p></span
                ></b>
              </p>
            </td>
          </tr>
        </thead>
        <tr style="mso-yfti-irow:1">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Satellite<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >GF-3<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:2">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Launch vehicle<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Long March 4C<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:3">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Launch site<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Taiyuan satellite launch center, China<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:4">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Satellite weight<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >2779 kg<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:5">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Designed lifetime<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >8 years<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:6">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Orbit altitude<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >755 km<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:7">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Orbit<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Sun-synchronous orbit<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:8">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Microwave category<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >C-band<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:9">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Satellite antennas<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Waveguide slot phased array<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:10">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Planar positioning accuracy<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >230 m without control points</span
              ><span
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >（<span lang="EN-US">incident angle 20°-50°</span>，<span
                  lang="EN-US"
                  >3σ</span
                >）<span lang="EN-US"><o:p></o:p></span
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:11">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Normal incident angle<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >20°</span
              ><span
                style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >～<span lang="EN-US">50°<o:p></o:p></span
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:12">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Extended incident angle<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="310"
            colspan="3"
            style="width:232.7pt;border-top:none;border-left:
  none;border-bottom:solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;
  mso-border-top-alt:solid #DDDDDD .75pt;mso-border-left-alt:solid #DDDDDD .75pt;
  mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >10°</span
              ><span
                style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >～<span lang="EN-US">60°<o:p></o:p></span
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:13">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Imaging mode<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Image spatial resolution/m<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Swath/km<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Polarization mode<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:14">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Sliding spotlight </span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">SL</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >1<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >10<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >single polarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:15">
          <td
            rowspan="6"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Band imaging mode<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Hyperfine band1</span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">UFS</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >3<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >30<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >single polarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:16">
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Hyperfine band2</span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">FSI</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >5<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >50<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Bipolarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:17">
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Hyperfine band3</span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">FSII</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >10<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >100<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Bipolarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:18">
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Standard strip </span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">SS</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >25<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >130<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Bipolarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:19">
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Fully polarized band 1</span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">QPSI</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >8<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >30<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Full-polarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:20">
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Fully polarized band2</span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">QPSII</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >25<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >40<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Full-polarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:21">
          <td
            rowspan="3"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Operational mode<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Narrow scan </span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">NSC</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >50<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >300<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Bipolarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:22">
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Wide scan </span
              ><span
                style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">WSC</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >100<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >500<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Bipolarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:23">
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Global Observation </span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">GLO</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >500<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >650<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Bipolarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:24">
          <td
            colspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Wave imaging mode </span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">WAV</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >10<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >5<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Full-polarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:25">
          <td
            rowspan="2"
            style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Extended incident angle </span
              ><span
                style="mso-bidi-font-size:
  10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                >（<span lang="EN-US">EXT</span>）<span lang="EN-US"
                  ><o:p></o:p></span
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Low incident angle<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >25<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >130<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Bipolarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
        <tr style="mso-yfti-irow:26;mso-yfti-lastrow:yes">
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >High incident angle<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >25<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >80<o:p></o:p
              ></span>
            </p>
          </td>
          <td
            width="47"
            style="width:35.0pt;border-top:none;border-left:none;border-bottom:
  solid #DDDDDD 1.0pt;border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;mso-pagination:widow-orphan;
  mso-element:frame;mso-element-frame-hspace:9.0pt;mso-element-wrap:around;
  mso-element-anchor-vertical:paragraph;mso-element-anchor-horizontal:margin;
  mso-element-top:-64.95pt;mso-height-rule:exactly"
            >
              <span
                lang="EN-US"
                style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
  mso-font-kerning:0pt"
                >Bipolarization<o:p></o:p
              ></span>
            </p>
          </td>
        </tr>
      </table>

      <p
        class="MsoNormal"
        align="left"
        style="text-align:left;mso-pagination:widow-orphan;
background:white"
      >
        <b
          ><span
            lang="EN-US"
            style='font-size:12.0pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
            ><o:p>&nbsp;</o:p></span
          ></b
        >
      </p>

      <p class="MsoNormal">
        <span lang="EN-US"><o:p>&nbsp;</o:p></span>
      </p>
    </div>
  
</template>
